import axiosInstance from "../axiosInstance";

export const salesByCategoryService = {
  // Create new sales by category entry
  create: async (data) => {
    try {
      const response = await axiosInstance.post("/sales-by-category", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Fetch all sales by category entries with pagination and filtering
  fetch: async (searchValue, query, client_id) => {
    try {
      let api = `/sales-by-category?`;
      if (client_id) api += `&client=${client_id}`;
      if (query?.length) api += `&${query}`;
      if (api && !api.includes("$limit")) {
        api += `&$limit=15`;
      }
      if (api && !api.includes("$skip")) {
        api += `&$skip=0`;
      }
      if (api && !api.includes("$sort")) {
        api += `&$sort[createdAt]=-1`;
      }
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Fetch categories for autocomplete
  fetchCategories: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let api = `/category?$limit=${limit}&$skip=${skip}&$select[]=name&$sort[name]=1`;
      if (client_id) api += `&client=${client_id}`;
      if (searchKey) api += `&name[$search]=${searchKey}`;
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Fetch clients for autocomplete
  fetchClients: async (searchKey, limit = 15, skip = 0) => {
    try {
      let api = `/client?$limit=${limit}&$skip=${skip}&$select[]=name&$sort[name]=1`;
      if (searchKey) api += `&name[$search]=${searchKey}`;
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get single entry
  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/sales-by-category/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update sales by category entry
  edit: async (data, id) => {
    try {
      const response = await axiosInstance.patch(
        `/sales-by-category/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete sales by category entry
  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/sales-by-category/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Wipe all records and recalculate from scratch
  regenerate: async (clientId) => {
    try {
      const response = await axiosInstance.post(
        `/regenerate-sales-by-category`,
        clientId ? { client_id: clientId } : {},
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
